import React, { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import img from "../../assets/img1.webp";
// import bg from "../../assets/why.png";

const WhyChoose = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Simplified image imports - replace these with your actual image paths
  // const solutionImg = "/path/to/solution.png";
  const slidesData = [
    {
      title: "Unrivaled Infrastructure",
      description:
        "Our data center is equipped with world-class facilities to support your data storage, computing, and connectivity needs. We offer high uptime guarantees, robust security protocols, and scalable options that grow with your business.",
      image: img,
    },
    {
      title: "Cutting-Edge IT Solutions",
      description:
        "Beyond just data storage, Multify provides a comprehensive range of IT services including software development, application management, cloud services, and IT consulting. We empower your business with the tools it needs to succeed in a rapidly evolving digital landscape.",
      image: img,
    },
    {
      title: "Security You Can Trust",
      description:
        "Security is our top priority. Our data center operates with industry-leading security measures, including 24/7 surveillance, fire suppression systems, and secure access protocols, ensuring your data remains protected at all times.",
      image: img,
    },
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slidesData.length);
  };

  const prevSlide = () => {
    setCurrentSlide(
      (prev) => (prev - 1 + slidesData.length) % slidesData.length
    );
  };

  useEffect(() => {
    const slideInterval = setInterval(() => {
      nextSlide();
    }, 5000);

    return () => clearInterval(slideInterval);
  }, []);

  return (
    <div className=" lg:pt-20 ">
      <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6 md:mb-12 text-center text-white">
        Why Choose Multify?
      </h2>

      <div className="relative max-w-6xl mx-auto">
        <div
          className="relative overflow-hidden rounded-lg md:rounded-2xl shadow-xl"
          style={{
            // backgroundImage: `url(${bg})`,
            // backgroundImage: "#000",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="backdrop-blur-sm bg-[#3918c31a]">
            <div className="flex items-center min-h-[300px] md:min-h-[400px]">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 items-center p-4 md:p-16 w-full">
                <div className="space-y-2 md:space-y-4 order-2 md:order-1">
                  <h4 className="text-[30px]  font-bold text-white mb-2">
                    {slidesData[currentSlide].title}
                  </h4>
                  <p className="text-white text-base sm:text-[16]  lg:text-[18]">
                    {slidesData[currentSlide].description}
                  </p>
                </div>
                <div className="flex justify-center items-center order-1 md:order-2 mb-4 md:mb-0">
                  <img
                    src={slidesData[currentSlide].image}
                    alt={slidesData[currentSlide].title}
                    className="max-w-full h-auto rounded-lg shadow-lg transition-all duration-500 max-h-[200px] md:max-h-[300px]"
                  />
                </div>
              </div>
            </div>

            {/* Navigation buttons - more visible on all devices */}
            <button
              onClick={prevSlide}
              aria-label="Previous slide"
              className="absolute left-2 md:left-4 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/40 p-1 md:p-2 rounded-full text-white transition-all z-10"
            >
              <ChevronLeft className="w-4 h-4 md:w-6 md:h-6" />
            </button>

            <button
              onClick={nextSlide}
              aria-label="Next slide"
              className="absolute right-2 md:right-4 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/40 p-1 md:p-2 rounded-full text-white transition-all z-10"
            >
              <ChevronRight className="w-4 h-4 md:w-6 md:h-6" />
            </button>

            {/* Slide indicators - improved for mobile */}
            <div className="absolute bottom-2 md:bottom-4 left-1/2 -translate-x-1/2 flex space-x-2 z-10">
              {slidesData.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  aria-label={`Go to slide ${index + 1}`}
                  className={`h-2 rounded-full transition-all ${
                    currentSlide === index
                      ? "bg-white w-4 md:w-6"
                      : "bg-white/50 w-2"
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChoose;
